import { useParams, useNavigate } from "react-router";
import { getTextFields } from "../variables/textField";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import SingleEntityContainer from "../../../../../shared/components/singleEntityContainer";
import { CloseButton } from "../../../../../shared/components/closeButton";
import useQuery from "../../../../../shared/components/hooks/useQuery";


const PaymentsView = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { loading, data } = useQuery(`/admin/payments/${id}`, null);
    const paymentData = (data as any)?.data;

    const paymentEditFields = getTextFields(paymentData);


    const closeDetailsView = () => {
        navigate("/fees/payments-listing");
    }
    const viewTitleBar = {
        title: "Fees Report Details",
        headerTitle: "Fees Report Details",
    };


  return (
     <ProfileBorderBox>
      <ViewContainer loading={loading} titleBar={viewTitleBar}>
        <div className="entity-container">
          <SingleEntityContainer
            entityFields={paymentEditFields}
            tooltips={<CloseButton onClick={closeDetailsView} />}
          >
        </SingleEntityContainer>
        </div>
      </ViewContainer>
    </ProfileBorderBox>

  );
}

export default PaymentsView;